import { reactive } from 'vue'

const state = reactive({
  visible: false,
  message: '',
  type: 'success', // 'success' | 'error' | 'info'
  _timer: null,
})

export function useToast() {
  function showToast(message, type = 'success') {
    if (state._timer) clearTimeout(state._timer)
    state.message = message
    state.type    = type
    state.visible = true
    state._timer  = setTimeout(() => { state.visible = false }, 3500)
  }

  return { toast: state, showToast }
}
